import axios from 'axios'
import { Toast } from 'vant'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_SHORT_URL, // url = base url + request url
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + window.$userToken
    config.headers['innerVersionCode'] = window.$innerVersionCode
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.config && error.config.skipToast) {
      return Promise.reject(error)
    }
    // 主动取消的请求不提示
    if (error.code === 'ERR_CANCELED' || error.name === 'CanceledError') {
      return Promise.reject(error)
    }
    // 轮询类请求在 iOS WebView 下常被系统取消（status 0），不弹 Toast 避免误报
    if (error.config && error.config.skipToastOnStatus0) {
      const isStatus0 = error.request && error.request.status === 0
      const isNetworkError = error.code === 'ERR_NETWORK' || error.message === 'Network Error'
      if (isStatus0 || isNetworkError) {
        return Promise.reject(error)
      }
    }
    Toast(error.message)
    return Promise.reject(error)
  }
)

export default service
